// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31AL6","footer":"styles_footer__Ivrd9"};